import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../utils/PropTypesDefinitions'
import CaptionFont from '../../../Theme/Fonts/Caption'

export type AddFavoriteItemProps = {
    /** text which is shown below the icon */
    label: string
    /** callback when the user presses on the component
     *
     * @TJS-type function
     * */
    onAdd: () => void
} & TestID

const AddFavoriteItem: FunctionComponent<AddFavoriteItemProps> = ({
    label,
    onAdd,
    testID,
}): ReactElement => {
    return (
        <Grid noExpand width={78} testID={testID}>
            <Touchable onPress={onAdd}>
                <Grid
                    noExpand
                    height={62}
                    width={62}
                    borderRadius={31}
                    marginX={3}
                    backgroundColor="onyx"
                    marginBottom={3}
                    center
                >
                    <FontelloIcon name="add-plus" fontSize={30} color="pearl" textAlign="center" />
                </Grid>

                <CaptionFont color="onyx" textAlign="center" numberOfLines={1}>
                    {label}
                </CaptionFont>
            </Touchable>
        </Grid>
    )
}

export default memo(AddFavoriteItem)
